import React from 'react'
import { ImageProps as Props } from './types'

const Image: React.SFC<Props> = ({ src, src2, alt }) =>
  <img src={src} srcSet={`${src} 1x, ${src2} 2x`} alt={alt} />

export default Image
